
define('hbars!bizzabo/templates/session', ['Handlebars'], function (Handlebars) { return Handlebars.compile('<nav>\n    <div>\n        <h2 class="gridSessionTime">{{timeFormatFrom24Hour attributes.start}} - {{timeFormatFrom24Hour attributes.end}}</h2>\n        <h1>{{attributes.name}}</h1>\n    </div>\n    <div>\n        <p>{{attributes.description}}</p>\n    </div>\n</nav>\n'); });

